<template>
  <SystemUserItemTable
    :asidePanelCanceledEventName="legacyAsidePanelCanceledEventName"
    :columns="columnsToDisplay"
    :defaultColumns="defaultColumns"
    :defaultSortField="defaultSortField"
    :isAsideOpen="isAsideOpen"
    :selectedModelId="selectedModelId"
    :selectionItemText="{
      label: 'selected',
      plural: 'users',
      singular: 'user',
    }"
    :setGettingStartedTooltipVisibility="showTooltip"
    :setSelectedModelId="setSelectedModelId"
    :useDropDownFilterComponent="FilterComponentConsts.SystemUserDropDownFilter"
    :useSearchContextFilterComponent="FilterComponentConsts.SystemUserSearchFilter"
    :viewport="viewport"
    @columnsChange="handleColumnsChange"
    @revertColumns="handleRevertColumns"
  />
</template>

<script>
import { FilterComponentConsts } from 'client/util/Constants';
import LocalStorageConsts from 'client/util/Constants/LocalStorageConstants';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';
import MainPanelWithItemTableMixin from 'components/MainPanel/mixins/MainPanelWithItemTableMixin';
import SystemUserItemTable from 'client/systemusers/SystemUserItemTable/SystemUserItemTable.vue';
import SystemUserItemTableColumns from 'client/systemusers/SystemUserItemTable/SystemUserItemTableColumns';
import UserStateMixin from 'components/mixins/UserStateMixin';

export default {
  name: 'UsersMainPanel',

  components: {
    SystemUserItemTable,
  },

  mixins: [MainPanelMixin, MainPanelWithItemTableMixin, UserStateMixin],

  data: () => ({
    availableColumns: SystemUserItemTableColumns,
    FilterComponentConsts,
    localStorageKey: LocalStorageConsts.systemUserMainPanelColumns,
  }),

  computed: {
    defaultSortField() {
      // $route is populated when vue router is enabled
      return this.$route ? this.$route.query.sort : '';
    },
  },

  created() {
    /**
     * @todo The actual string is used instead of UserDetailsAsidePanel.FULL_CANCELED_EVENT_NAME
     * because importing UserDetailsAsidePanel caused test failures in backbone tests.
     * Note: This may no longer be necessary but it is beyond the scope of my current work to
     * determine if it can be removed.
     */
    this.legacyAsidePanelCanceledEventName = 'user-details:canceled';

    this.defaultColumns = this.usersMainPanelDefaultColumns;
  },
};
</script>
